import { useCallback } from 'react'
import { createAttachmentId } from './createAttachmentId'
import { MAX_MESSAGE_ATTACHMENTS } from './aiAskBarLayoutConstants'

export function useAiAskBarFileInputHandler({ attachmentsRef, setAttachments, startUpload }) {
  return useCallback(
    (event) => {
      const { files } = event.target
      if (!files?.length) {
        event.target.value = ''
        return
      }
      const picked = Array.from(files)
      const remaining = MAX_MESSAGE_ATTACHMENTS - attachmentsRef.current.length
      if (remaining <= 0) {
        event.target.value = ''
        return
      }
      const added = picked.slice(0, remaining).map((file) => ({
        id: createAttachmentId(),
        file,
        previewUrl: file.type.startsWith('image/') ? URL.createObjectURL(file) : undefined,
      }))
      setAttachments((prev) => [...prev, ...added])
      added.forEach((attachment) => startUpload?.(attachment))
      event.target.value = ''
    },
    [attachmentsRef, setAttachments, startUpload],
  )
}
